import { useCallback } from "react";

import BigNumber from "bignumber.js";
import { useIntl } from "react-intl";

const DEFAULT_PRECISION = 2;
const FULL_FRACTION_DIGITS = 20;

export type FormattedMoney = {
  display: string;
  full: string;
};

export const useFormatMoney = () => {
  const { formatNumber } = useIntl();

  const formatMoney = useCallback(
    (
      value: null | number | string | undefined,
      precision = DEFAULT_PRECISION,
    ): FormattedMoney => {
      const parsed = new BigNumber(value ?? 0);
      const safe = parsed.isFinite() ? parsed : new BigNumber(0);

      const floored = Number(safe.toFixed(precision, BigNumber.ROUND_DOWN));
      const display = formatNumber(floored, {
        maximumFractionDigits: precision,
      });

      const full = formatNumber(Number(safe.toFixed()), {
        maximumFractionDigits: FULL_FRACTION_DIGITS,
      });

      return { display, full };
    },
    [formatNumber],
  );

  return { formatMoney };
};
